<app-tabs>
  <app-intelligence-tab></app-intelligence-tab>
</app-tabs>
